<script setup lang="ts">
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';

withDefaults(
  defineProps<{
    label?: string
  }>(),
  {
    label: 'Back',
  },
);

const emit = defineEmits<{
  back: []
}>();

const cn = classNames('back-button');
</script>

<template>
  <button
    type="button"
    :class="cn()"
    :aria-label="label"
    @click="emit('back')"
  >
    <BaseIcon
      type="main"
      name="arrow-left"
      :width="24"
      :height="24"
      :class="cn('arrow')"
      aria-hidden="true"
    />
  </button>
</template>

<style lang="scss" scoped>
.back-button {
  --back-button-arrow-transform: translateX(0);

  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  outline: none;

  &:hover {
    --back-button-arrow-transform: translateX(-10px);
  }

  &__arrow {
    transition: transform 0.3s ease-in-out;
    transform: var(--back-button-arrow-transform);
  }

  @media (max-width: 768px) {
    &:hover {
      --back-button-arrow-transform: translateX(0);
    }
  }
}
</style>
